import { Component, Input } from '@angular/core';
import { ZoningCode, ZoningCodeVersion } from 'src/app/modules/instance/models';
import { ZoningCodeVersionService, InstanceService } from 'src/app/modules/instance/services';
import { ZoningCodeVersionButtons } from 'src/app/modules/instance/models';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { filter } from 'rxjs/operators';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';

@Component({
    standalone: false,
    selector: 'app-zoning-code-version-recalculate-button',
    templateUrl: './zoning-code-version-recalculate-button.component.html',
    styleUrls: ['./zoning-code-version-recalculate-button.component.scss']
})
export class zoningCodeVersionRecalculateButtonComponent extends ZoningCodeVersionButtons {
    constructor(
        private readonly zcVersionService: ZoningCodeVersionService,
        private readonly instanceService: InstanceService,
        private readonly dialog: MatDialog,
    ) {
        super();
    }

    ngOnInit(): void {
    }

    @Input()
    public zoningCode: ZoningCode;

    @Input()
    public zoningCodeVersion: ZoningCodeVersion;

    @Input()
    public task: ITaskModel;

    public recalculateZCVersion(event: Event) {
        event.stopPropagation();

        if (!this.zoningCodeVersion.hasTasks && !this.task) {
            this.zcVersionService.recalculateZCVersion(this.instance, this.zoningCodeVersion, this.zoningCode);
            return;
        }

        this.openRecalculateTaskDialog();
    }

    get instance() {
        return this.task ? this.instanceService.getInstanceById(this.task.instanceId) : this.instanceService.selectedInstance;
    }

    private openRecalculateTaskDialog() {
        const dialogConfig = new MatDialogConfig();

        const title = 'Start recalculation';

        const topContent = 'The calculation is in process.',
            bottomContent = 'Do you want to stop it and start recalculation?',
            okButtonColor = 'warn';

        dialogConfig.autoFocus = true;
        dialogConfig.data = { title, topContent, bottomContent, okButtonColor };


        const recalculateDialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
        recalculateDialogRef.afterClosed().pipe(
            filter(isConfirm => isConfirm)
        )
            .subscribe(() => {
                this.zcVersionService.recalculateZCVersion(
                    this.instance,
                    this.zoningCodeVersion,
                    this.zoningCode,
                    true);
            });
    }

}
